<template>
  <section>
    <HeroSection headName="Cadastro de Lista" :searchBar="false" :addButton="false">
    </HeroSection>

    <div class="container">

      <form class="form">
        <div class="form__box" v-if="loading">
          <h2 class="form__name">
            <DataLoading rows="1" height="50px" />
          </h2>

          <div class="form__content">
            <DataLoading rows="4" height="80px" />
          </div>
        </div>

        <div class="form__wrap" v-if="!loading">
          <div class="form__box" v-if="isUserAdmin()">
            <h2 class="form__name">
              Identificação
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormSearch label="Pesquisar Utilizador" v-model:modelValue="searcher" v-model:modelItem="sender" :dataList="senderListData" />
              </div>

              <div class="form__row">
                <FormInput label="Nome de Utilizador" :required="true" v-model:modelValue="model.sender.senderName" width="50%"/>

                <FormInput label="E-mail do Utilizador" :required="true" v-model:modelValue="model.sender.senderReplyToEmail" width="50%"/>
              </div>
            </div>
          </div>

          <div class="form__box">
            <h2 class="form__name">
              Dados da Lista
            </h2>

            <div class="form__content">
              <div class="form__row">
                <FormInput label="Nome da Lista" :required="true" v-model:modelValue="model.listName"/>
              </div>

              <div class="form__row form__row--nowrap">
                <FormCheckbox label="Ignorar 1ª linha" :required="true" v-model:modelValue="model.listNotFirstRow" />
              </div>

              <div class="form__row">
                <FormFile label="Selecionar Arquivo" :required="true" v-model:fileContent="fileContent" accept=".csv" />
                <div class="form__obs">baixar arquivo de importação modelo: <a href="https://cdn.flize.cloud/modelo.csv" title="Baixar arquivo modelo" download>Clique Aqui.</a></div>
              </div>
            </div>
          </div>

          <FormBottom :data="button" @submit="submit()" />

        </div>
      </form>
    </div>
  </section>
</template>

<script>

import HeroSection from '@components/_partials/HeroSection.vue';
import DataLoading from '@components/_partials/DataLoading.vue';
import FormInput from '@components/_form/FormInput.vue';
import FormCheckbox from '@components/_form/FormCheckbox.vue';
import FormSearch from '@components/_form/FormSearch.vue';
import FormBottom from '@components/_form/FormBottom.vue';
import FormFile from '@components/_form/FormFile.vue';
import { baseUrl } from '@helpers/functions';
import lista from '@services/lista';
import usuario from '@services/usuario';
import storage from '@/config/storage';
import moment from 'moment';

export default {
  components: {
    HeroSection,
    DataLoading,
    FormInput,
    FormCheckbox,
    FormSearch,
    FormBottom,
    FormFile
  },
  data() {
    return {
      loading: false,
      button: { spinner: false, label: 'Salvar Lista', color: 'primary' },
      model: { sender: {}, listName: '', listNotFirstRow: false },
      fileContent: {},
      senderListData: [],
      sender: {},
      dataList: [],
      pagination: {},
      searcher: '',
      search: '',
      isCpf: true,
      helpers: {
        cpf: '',
        cnpj: ''
      }
    }
  },
  methods: {
    baseUrl,
    loadForm: function(_id) {
      const _this = this;
      _this.loading = true;

      lista.show(_id).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.model = res.data;
          _this.sender = res.data.sender;
          _this.loading = false;
        }
      });
    },
    submit() {
      const _this = this;
      const _id = _this.hasIdx();
      const button = _this.button;

      let data = _this.model;


      _this.button = {
        spinner: true,
        label: 'Salvando...',
        color: 'warning'
      }
      lista.save(_id, _this.fileContent, data).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          _this.button = {
            spinner: false,
            label: 'Salvo com sucesso!',
            color: 'success'
          }

          setTimeout(() => this.$router.push('/listas'), 1000);
        }

        if(typeof res === 'undefined' || !res.success) {
          _this.button = {
            spinner: false,
            label: 'Houve um erro ao processar.',
            color: 'danger'
          }
          setTimeout(() => _this.button = button, 3000);
        }
      })

    },
    hasIdx() {
      const _this = this;
      return _this.$route.params.id ? _this.$route.params.id : null;
    },
    isUserAdmin() {
      const local = 'mail4fly--user';
      const user = storage.get(local);
      return user && user.role === 'admin' ? true : false;
    },
    getNow() {
      return moment().format('DD/MM/YYYY HH:mm:ss');
    }
  },
  watch: {
    '$route.params.page'(paged) {
     this.initLoad(paged);
    },
    'searcher'(search) {
      const _this = this;
      if(search && search.length > 3) {
        usuario.retrieve({ search }).then((res) => {
        if(typeof res !== 'undefined' && res.success) {
          const { docs } = res.data;
          _this.senderListData = docs;
        }
      });
      }

      if(!search || search.length == 0) {
        _this.senderListData = [];
      }
    },
    'sender'(sender) {
      const _this = this;
      const { _id, senderName, senderReplyToEmail  } = sender;

      _this.model.sender = { _id, senderName, senderReplyToEmail };
      _this.model.senderId = _id;
      _this.model.senderName = senderName;
      _this.senderListData = [];
      _this.searcher = '';
    }
  },
  mounted(){
    const _id = this.hasIdx();
    if(_id) this.loadForm(_id);
    if(!_id) this.model.listName = `Lista criada em ${this.getNow()}`;
  }
};

</script>
